import { render, staticRenderFns } from "./StoryblokAccordion.vue?vue&type=template&id=5cb6dbd4&scoped=true&"
import script from "./StoryblokAccordion.vue?vue&type=script&lang=ts&"
export * from "./StoryblokAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./StoryblokAccordion.vue?vue&type=style&index=0&id=5cb6dbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb6dbd4",
  null
  
)

export default component.exports